import { Polygon, MultiPolygon, Point, Feature } from "@turf/helpers";
import { DesignationFeatureProps } from "react-migration/domains/constraints/components/ConstraintLayer/DesignationLayer";
import { ClusteredPermitsFeatureProps } from "./types";

let _lastFeatures: Feature<Point | Polygon | MultiPolygon, ClusteredPermitsFeatureProps>[];
let _featureIsVisible: (featureProperties: DesignationFeatureProps) => boolean;

/**
 * Memoises the featureIsVisible function for the given features.
 *
 * **The reference to features is used to determine if the `featureIsVisible`
 * function should be recalculated.**
 */
export function getCachedFeatureIsVisible(
  features: Feature<Point | Polygon | MultiPolygon, ClusteredPermitsFeatureProps>[]
): (featureProperties: DesignationFeatureProps) => boolean {
  if (_lastFeatures !== features) {
    _lastFeatures = features;

    const featureIds = new Set(features.map((f) => f.id));

    _featureIsVisible = (featureProperties: DesignationFeatureProps) => {
      return featureIds.has(featureProperties.designation_id);
    };
  }

  return _featureIsVisible!;
}
